import dayjs from "dayjs";
import { TripOptimization } from "../../hooks/react-query/linehaul/useLoadBoard";

export const mockTripOptimization = {
  default: {
    tripNumber: 3025801,
    originSicCode: "ATB-SEFL",
    destinationSicCode: "DAL",
    carrierCode: "L021",
    carrierName: "SCHNEIDER NATIONAL CARRIERS INC.",
    bookingNumber: "B1234567",
    trailerNumber: "",
    pickupDate: dayjs("2025-07-15T00:00:00"),
    gateCutDate: dayjs("2025-07-27T00:00:00"),
    totalBills: 30,
    loadedBills: 25,
    palletsCount: 25,
    piecesCount: 1,
    totalWeight: 30000,
    stops: [],
    loadedWeight: 25000,
    shipments: [
      {
        shipmentId: 134415255,
        proNumber: "164926248",
        tags: [],
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        pallets: 1,
        pieces: 0,
        weight: 2264,
      },
      {
        shipmentId: 134427039,
        proNumber: "164926511",
        tags: [],
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        pallets: 3,
        pieces: 0,
        weight: 3584,
      },
      {
        shipmentId: 134435081,
        proNumber: "164926701",
        tags: [],
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        pallets: 1,
        pieces: 0,
        weight: 290,
      },
      {
        shipmentId: 134440324,
        proNumber: "164927691",
        tags: [],
        originSicCode: "ATB-SEFL",
        destinationSicCode: "SFO",
        pallets: 1,
        pieces: 0,
        weight: 1308,
      },
      {
        shipmentId: 134441988,
        proNumber: "164926719",
        tags: ["DTCL"],
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        pallets: 4,
        pieces: 0,
        weight: 3110,
      },
    ],
    employeeDrivers: [
      {
        id: 2,
        name: "Mike Johnson",
        refCode: "MJ002",
        driverId: 102,
        ratePerMile: 2.8,
        order: 1,
        loadBoardScheduleId: null,
      },
      {
        id: 3,
        name: "Sarah Wilson",
        refCode: "SW003",
        driverId: 103,
        ratePerMile: 2.2,
        order: 2,
        loadBoardScheduleId: null,
      },
    ],
    shipmentDestinationDetails: [
      {
        destinationSicCode: "ONT",
        loadedBills: 4,
        loadedWeight: 1247,
        piecesCount: 1,
        palletsCount: 3,
      },
      {
        destinationSicCode: "SFO",
        loadedBills: 3,
        loadedWeight: 6718,
        piecesCount: 0,
        palletsCount: 6,
      },
    ],
  },
  withStops: {
    tripNumber: 3025888,
    originSicCode: "DAL",
    destinationSicCode: "HTX",
    carrierCode: "L021",
    carrierName: "SCHNEIDER NATIONAL CARRIERS INC.",
    bookingNumber: "B1234567",
    trailerNumber: "",
    pickupDate: dayjs("2025-07-15T00:00:00"),
    gateCutDate: dayjs("2025-07-27T00:00:00"),
    totalBills: 30,
    loadedBills: 25,
    palletsCount: 25,
    piecesCount: 1,
    totalWeight: 30000,
    stops: ["ONT"],
    loadedWeight: 25000,
    employeeDrivers: [
      {
        id: 1,
        order: 1,
        name: "John Doe",
        loadBoardScheduleId: null,
        driverId: 101,
        ratePerMile: 2.5,
        refCode: "DR123",
      },
    ],
    shipmentDestinationDetails: [
      {
        destinationSicCode: "ONT",
        loadedBills: 4,
        loadedWeight: 1247,
        piecesCount: 1,
        palletsCount: 3,
      },
      {
        destinationSicCode: "SFO",
        loadedBills: 3,
        loadedWeight: 6718,
        piecesCount: 0,
        palletsCount: 6,
      },
    ],
    shipments: [
      {
        shipmentId: 134415255,
        proNumber: "164926248",
        tags: [],
        originSicCode: "DAL",
        destinationSicCode: "ONT",
        pallets: 1,
        pieces: 0,
        weight: 2264,
      },
      {
        shipmentId: 134427039,
        proNumber: "164926511",
        tags: [],
        originSicCode: "DAL",
        destinationSicCode: "ONT",
        pallets: 3,
        pieces: 0,
        weight: 3584,
      },
      {
        shipmentId: 134435081,
        proNumber: "164926701",
        tags: [],
        originSicCode: "DAL",
        destinationSicCode: "ONT",
        pallets: 1,
        pieces: 0,
        weight: 290,
      },
      {
        shipmentId: 134440324,
        proNumber: "164927691",
        tags: [],
        originSicCode: "DAL",
        destinationSicCode: "LAX",
        pallets: 1,
        pieces: 0,
        weight: 1308,
      },
      {
        shipmentId: 134441988,
        proNumber: "164926719",
        tags: ["DTCL"],
        originSicCode: "DAL",
        destinationSicCode: "ONT",
        pallets: 4,
        pieces: 0,
        weight: 3110,
      },
    ],
    groupedShipmentsByStop: [
      {
        shipmentId: 134435052,
        proNumber: "164926933",
        tags: ["LG", "UC"],
        originSicCode: "DAL",
        destinationSicCode: "ONT",
        pallets: 1,
        pieces: 0,
        weight: 250,
      },
      {
        shipmentId: 134435053,
        proNumber: "164926934",
        tags: ["DTCL"],
        originSicCode: "DAL",
        destinationSicCode: "ONT",
        pallets: 2,
        pieces: 0,
        weight: 500,
      },
    ],
    uniqueDestinationSics: ["ONT"],
  },
} as const satisfies Record<string, TripOptimization>;
